import React, { useState } from 'react';

const ChangeCertificate = () => {
  const [liveCertificate, setLiveCertificate] = useState('');
  const [myCertificate, setMyCertificate] = useState('');
  const [status, setStatus] = useState(1);

  const handleLiveCertificateChange = (e) => {
    setLiveCertificate(e.target.value);
  };

  const handleMyCertificateChange = (e) => {
    setMyCertificate(e.target.value);
  };

  const handleStatusChange = (e) => {
    setStatus(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Live Certificate:', liveCertificate);
    console.log('My Certificate:', myCertificate);
    console.log('Status:', status);
    // Implement further logic for submission if needed
  };

  const containerStyle = {
    padding: '20px',
    backgroundColor: '#f4f4f9',
    borderRadius: '8px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    maxWidth: '600px',
    margin: '0 auto',
    fontSize: '14px',
  };

  const formGroupStyle = {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '15px',
  };

  const labelStyle = {
    fontWeight: 'bold',
    marginBottom: '5px',
  };

  const inputStyle = {
    padding: '8px',
    fontSize: '14px',
    borderRadius: '4px',
    border: '1px solid #ccc',
  };

  const buttonStyle = {
    padding: '8px 16px',
    backgroundColor: '#007bff',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '14px',
    marginTop: '10px',
  };

  return (
    <div style={containerStyle}>
      <h2 style={{ textAlign: 'center', marginBottom: '20px', fontSize: '18px' }}>
        Change Certificate
      </h2>

      <form onSubmit={handleSubmit}>
        {/* Live Certificate Field */}
        <div style={formGroupStyle}>
          <label style={labelStyle}>Live Certificate</label>
          <input
            type="text"
            style={inputStyle}
            value={liveCertificate}
            onChange={handleLiveCertificateChange}
            placeholder="C:/inetpub/vhosts/odhgroups.com/odhapi.odhgroups.com/Certificate/UAT.cer"
          />
        </div>

        {/* My Certificate Field */}
        <div style={formGroupStyle}>
          <label style={labelStyle}>My Certificate</label>
          <input
            type="text"
            style={inputStyle}
            value={myCertificate}
            onChange={handleMyCertificateChange}
            placeholder="C:/inetpub/vhosts/odhgroups.com/odhapi.odhgroups.com/Certificate/certificate.pfx"
          />
        </div>

        {/* Status Field */}
        <div style={formGroupStyle}>
          <label style={labelStyle}>Status</label>
          <select
            style={inputStyle}
            value={status}
            onChange={handleStatusChange}
          >
            <option value={1}>1</option>
            <option value={0}>0</option>
          </select>
        </div>

        {/* Submit Button */}
        <button type="submit" style={buttonStyle}>
          Submit
        </button>
      </form>
    </div>
  );
};

export default ChangeCertificate;
